import React from 'react';
import { Box, Fade, Tooltip } from '@material-ui/core';

export const ThreadTagsBadge = ({ tags }: { tags: any }) => {
    return (
        <Fade in={true} unmountOnExit>
            <Box
                style={{
                    display: 'flex',
                    gap: 5,
                    alignSelf: 'flex-end',
                }}
            >
                {tags.map(({ _id, name, color }: any) => (
                    <Tooltip title={name} key={_id}>
                        <Box
                            key={_id}
                            style={{
                                backgroundColor: color,
                                width: 12,
                                height: 12,
                                borderRadius: '50%',
                            }}
                        />
                    </Tooltip>
                ))}
            </Box>
        </Fade>
    );
};
